import { NumberSchema } from '@utils';
import { lineSegment, point } from './constructors';
import { z } from 'zod';

// #region Schema

export const LineSegmentSchema = z
  .array(NumberSchema, {
    message: 'LineSegment must be an array of four numbers, [x1, y1, x2, y2]'
  })
  .length(4)
  .transform(([x1, y1, x2, y2]) => lineSegment(point(x1, y1), point(x2, y2)));
